import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Container, Row, Col, Form } from "react-bootstrap";
import axiosInstance from "Services/axiosInstance";
import { FaEdit, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import DataTable from "react-data-table-component";
import { BsPencilSquare, BsTrash } from "react-icons/bs";

const UploadScreen = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [calenderList, setCalenderList] = useState([]);
  const [planIdsList, setPlanIdsList] = useState([]);
  const [reqIdsList, setReqIdsList] = useState([]);
  const [slotDate, setSlotDate] = useState(null);
  const [slotStart, setSlotStart] = useState(null);
  const [slotEnd, setSlotEnd] = useState(null);
  const [slots, setSlots] = useState([]);
  const [editSlots, setEditSlots] = useState([]);

  const [getinterviewdetails, setgetinterviewdetails] = useState([]);
  const [planIds, setPlanIds] = useState();
  const [reqId, setReqId] = useState();

  const [selectedStage, setSelectedStage] = useState("");
const [selectedMode, setSelectedMode] = useState("");


  const [clientid, setClientId] = useState("");
  const [clientname, setClientName] = useState("");
  const [deletee, setdelete] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedEditDate, setSelectedEditData] = useState({});

  const [showuploadmodal, setShowUploadModal] = useState(false);

  const [file, setFile] = useState(null);
  const handleAddSlot = () => {
    if (slotDate && slotStart && slotEnd) {
      const newSlot = {
        date: slotDate.toISOString().split("T")[0],
        start_time: slotStart.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
        end_time: slotEnd.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
      };
      setSlots([...slots, newSlot]);
      setSlotDate(null);
      setSlotStart(null);
      setSlotEnd(null);
    }
  };

  const handleEditAddSlot = () => {
    if (slotDate && slotStart && slotEnd) {
      const newSlot = {
        date: slotDate.toISOString().split("T")[0],
        start_time: slotStart.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
        end_time: slotEnd.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
      };
      setEditSlots([...editSlots, newSlot]);
      setSlotDate(null);
      setSlotStart(null);
      setSlotEnd(null);
    }
  };

  const handleAddModal = (candidate) => {
    setShowAddModal(true);
  };

  const handleSubmitAddModal = async (formData) => {
    try {
      const dataObject = Object.fromEntries(formData.entries());
      dataObject.slots = slots;
      console.log(dataObject,"frwerqawda")
      const response = await axios.post(
        "https://api.pixeladvant.com/api/interviewers/",
        dataObject
      );
      if (response?.data?.success) {
        setShowAddModal(false);
        setClientId("");
        setClientName("");
      }
    } catch (err) {
      console.error("Error create calender table data", err);
    }
  };

  const handleSubmitEditModal = async (formData, interviewer_id) => {
    try {
      const dataObject = Object.fromEntries(formData.entries());
      dataObject.slots = editSlots;
      dataObject.interviewer_id = interviewer_id;
      const response = await axios.put(
        "https://api.pixeladvant.com/api/interviewers/",
        dataObject
      );
      if (response?.data?.success) {
        setShowEditModal(false);
        window.location.reload();
      }
    } catch (err) {
      console.error("Error update calender table data", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          "https://api.pixeladvant.com/api/interviewers/"
        );

        if (response?.data?.success) {
          setCalenderList(response?.data?.data);
        }
      } catch (err) {
        console.error("Error fetching calender table data", err);
      }
    };

    fetchData();
  }, [showDeleteModal, deletee, showAddModal,showuploadmodal]);

  useEffect(() => {
    const fetchData = async () => {
      try {
      } catch (err) {
        console.error("Error fetching calender table data", err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const designRes = await axios.get(
          "https://api.pixeladvant.com/design_screen_list_data_interviewer/"
        );

        if (designRes.data?.success) {
          const { plan_id, requisition_id } = designRes.data.data;
          setPlanIdsList(plan_id || []);
          setReqIdsList(requisition_id || []);
        }
      } catch (error) {
        console.error("Dropdown fetch error:", error);
      }
    };
    fetchDropdownData();
  }, []);

  useEffect(() => {
    if (reqId) {
      const getClientdetails = async () => {
        const getclientdetails = await axios.post(
          "https://api.pixeladvant.com/api/client-lookup/",
          {
            plan_id: planIds,
            req_id: reqId,
          }
        );
        if (getclientdetails?.data?.success) {
          setClientId(getclientdetails?.data?.data?.client_id);
          setClientName(getclientdetails?.data?.data?.client_name);
        }
        const response = await axiosInstance.post(
          "https://api.pixeladvant.com/api/job/metadata/",
          {
            plan_id: planIds,
            req_id: reqId,
          }
        );

        if (response?.data?.success) {
          setgetinterviewdetails(response?.data?.data);
        }
      };
      getClientdetails();
    }
  }, [reqId, planIds]);
  const handleRemoveSlot = (index) => {
    const updatedSlots = [...slots];
    updatedSlots.splice(index, 1);
    setSlots(updatedSlots);
  };
  const handleRemoveeditSlot = (index) => {
    const updatedSlots = [...editSlots];
    updatedSlots.splice(index, 1);
    setEditSlots(updatedSlots);
  };

  // Add two new states
const [editSelectedStage, setEditSelectedStage] = useState("");
const [editSelectedMode, setEditSelectedMode] = useState("");

// When opening Edit Modal, initialize values


// Reuse functions for edit modal but update edit states
const handleEditStageChange = (stage) => {
  setEditSelectedStage(stage);

  const found = selectedEditDate?.interview_design?.find(
    (d) => d.interviewer_stage === stage
  );
  if (found) {
    setEditSelectedMode(found.interview_mode);
  }
};

const handleEditModeChange = (mode) => {
  setEditSelectedMode(mode);

  const found = selectedEditDate?.interview_design?.find(
    (d) => d.interview_mode === mode
  );
  if (found) {
    setEditSelectedStage(found.interviewer_stage);
  }
};


  const handleEdit = async (item) => {
  setShowEditModal(true);

  const metadata = await axiosInstance.post(
    "https://api.pixeladvant.com/api/job/metadata/",
    {
      plan_id: item?.plan_id,
      req_id: item?.req_id,
    }
  );

  const enrichedItem = {
    ...item,
    interview_design: metadata?.data?.data?.interview_design || [],
  };

  setSelectedEditData(enrichedItem);
  setEditSlots(item?.slots || []);
    // initialize mode & stage from existing record
  setEditSelectedMode(item?.interview_mode || "");
  setEditSelectedStage(item?.interviewer_stage || "");
};



  const handleupload = async (e)=>{
    e.preventDefault();

    if (!file) return alert('Please select a file first.');

    const formData = new FormData();
    formData.append('file', file); 

    try {
      const response = await axios.post('https://api.pixeladvant.com/api/interviewers/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      if(response?.data?.success){
        setShowUploadModal(false)
         window.location.reload();
      }
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Failed to upload file.');
    }
  }

  const handleDelete = async (interviewer_id) => {
    try {
      const response = await axios.delete(
        "https://api.pixeladvant.com/api/interviewers/",
        {
          data: {
            interviewer_id,
          },
        }
      );
      if (response?.data?.success) {
        setdelete(true);
      }
    } catch (err) {
      console.error("Error fetching recruiter table data", err);
    }
  };

const handleStageChange = (stage) => {
  setSelectedStage(stage);

  const found = getinterviewdetails?.interview_design?.find(
    (d) => d.interviewer_stage === stage
  );
  if (found) {
    setSelectedMode(found.interview_mode);
  }
};

const handleModeChange = (mode) => {
  setSelectedMode(mode);

  const found = getinterviewdetails?.interview_design?.find(
    (d) => d.interview_mode === mode
  );
  if (found) {
    setSelectedStage(found.interviewer_stage);
  }
};

 const columns = [
   {
     name: "S.No",
     selector: (row, index) => index + 1,
     sortable: true,
     width: "90px",
     center: true,
   },
   {
     name: "Req ID",
     selector: (row) => row.req_id,
     sortable: true,
     center: true,
   },
   {
     name: "Client ID",
     selector: (row) => row.client_id,
     sortable: true,
     center: true,
   },
   {
     name: "First Name",
     selector: (row) => row.first_name,
     sortable: true,
   },
   {
     name: "Last Name",
     selector: (row) => row.last_name,
     sortable: true,
   },
   {
     name: "Job Title",
     selector: (row) => row.job_title,
     sortable: true,
   },
   {
     name: "Interview Mode",
     selector: (row) => row.interview_mode,
     sortable: true,
   },
   {
     name: "Interviewer Stages",
     selector: (row) => row.interviewer_stage,
     sortable: true,
   },
   {
     name: "Email ID",
     selector: (row) => row.email,
     cell: (row) => <a href={`mailto:${row.email}`}>{row.email}</a>,
     sortable: true,
   },
{
  name: "Slots",
  cell: row => {
    const visibleSlots = row.slots?.slice(0, 2) || []; // show first 2
    const hiddenCount = row.slots?.length > 2 ? row.slots.length - 2 : 0;

    return (
      <div>
        {visibleSlots.map((slot, i) => (
          <span key={i} className="badge bg-primary me-1 mb-1">
            {slot.date} ({slot.start_time}-{slot.end_time})
          </span>
        ))}
        {hiddenCount > 0 && (
          <span className="badge bg-secondary">+{hiddenCount} more</span>
        )}
      </div>
    );
  },
  grow: 2,
},

 {
  name: "Action",
  cell: row => (
    <div className="d-flex justify-content-center align-items-center gap-2">
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => handleEdit(row)}
      >
        <BsPencilSquare />
      </Button>

      <Button
        variant="outline-danger"
        size="sm"
        onClick={() => handleDelete(row.interviewer_id)}
      >
        <BsTrash />
      </Button>
    </div>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
  center: true,
}

 ];

         const tableStyles = {
  header: {
    style: {
      fontSize: '18px',
      fontWeight: '600',
      padding: '16px',
    },
  },
  headRow: {
    style: {
      backgroundColor: "linear-gradient(135deg, #0F172A 0%, #374151 100%)", // dark slate header
      borderBottomWidth: '2px',
      borderBottomColor: '#CBD5E1',
      borderBottomStyle: 'solid',
    },
  },
  headCells: {
    style: {
      fontSize: '15px',
      fontWeight: '700',
      color: '#F9FAFB', // light text
      padding: '14px 12px',
      letterSpacing: '0.3px',
      whiteSpace: 'normal',   // 👈 prevents cutting off
      wordBreak: 'break-word' // 👈 wraps long text
    },
  },
  rows: {
    style: {
      minHeight: '52px',
      fontSize: '14px',
      fontWeight: '500',
      '&:nth-of-type(odd)': {
        backgroundColor: '#F9FAFB', // zebra striping
      },
      '&:hover': {
        backgroundColor: '#E0F2FE  ', // light hover
        cursor: 'pointer',
      },
    },
  },
  cells: {
    style: {
      padding: '12px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
};


  return (
    <Container fluid className="p-4 bg-light rounded">
      <div className="row d-flex justify-content-between">
        <div className="col-2">
          <h4 className="mb-4 fw-bold">Interview Calendar</h4>
        </div>

        <div className="col-2">
          <Button
            variant="success"
            size="sm"
            className="me-2"
            onClick={handleAddModal}
          >
            Add
          </Button>
          <Button
            variant="secondary"
            size="sm"
            className="me-2"
            onClick={() => setShowUploadModal(true)}
          >
            Upload
          </Button>
        </div>
      </div>
      {/* <Table
        responsive
        bordered
        hover
        className="bg-white shadow-sm rounded text-center align-middle"
      >
        <thead className="bg-secondary text-white">
          <tr>
            <th>S.No</th>
            <th>Req ID</th>
            <th>Client ID</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Job Title</th>
            <th>Interview Mode</th>
            <th>Interviewer Stages</th>
            <th>Email ID</th>
            <th>Slots</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {calenderList?.length > 0 ? calenderList.map((item, idx) => (
            <tr key={item?.interviewer_id}>
              <td>{idx + 1}</td>
              <td>{item?.req_id}</td>
              <td>{item?.client_id}</td>
              <td>{item?.first_name}</td>
              <td>{item?.last_name}</td>
              <td>{item?.job_title}</td>
              <td>{item?.interview_mode}</td>
              <td>{item?.interviewer_stage}</td>
              <td>
                <a href={`mailto:${item.email}`}>{item.email}</a>
              </td>
              <td>
                {item?.slots?.map((row, index) => (
                  <span key={index} className="badge bg-primary me-1 mb-1">
                    {row?.date} ({row?.start_time} - {row?.end_time})
                  </span>
                ))}
              </td>{" "}
              <td>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "100%" }}
                >
                  <FaEdit
                    style={{
                      cursor: "pointer",
                      color: "#0d6efd",
                      marginRight: "10px",
                    }}
                    onClick={() => handleEdit(item)}
                  />
                  <FaTrash
                    style={{ cursor: "pointer", color: "#dc3545" }}
                    onClick={() => handleDelete(item?.interviewer_id)}
                  />
                </div>
              </td>
            </tr>
          )):<tr className="text-center"><td colSpan={12}>No Data Found</td></tr>}
        </tbody>
      </Table> */}

      <DataTable
        // title="Interview Calendar"
        columns={columns}
        data={calenderList || []}
        striped
        fixedHeader
        dense
        persistTableHead
        customStyles={tableStyles}
        responsive
        defaultSortField="req_id"
        noDataComponent="No Data Found"
      />

      {/* create modal */}
      <Modal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Interview Calender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="calenderForm">
            {/* Existing Fields */}
            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Planning ID</label>
                <select
                  className="form-select"
                  name="planningId"
                  onChange={(e) => setPlanIds(e.target.value)}
                >
                  <option value="">Select Planning ID</option>
                  {planIdsList.map((id) => (
                    <option value={id}>{id}</option>
                  ))}
                </select>
              </div>
              <div className="col">
                <label>Req ID</label>
                <select
                  className="form-select"
                  name="req_id"
                  onChange={(e) => setReqId(e.target.value)}
                >
                  <option value="">Select Req ID</option>
                  {reqIdsList.map((id) => (
                    <option value={id}>{id}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Client ID</label>
                <input
                  className="form-control"
                  name="client_id"
                  readOnly
                  defaultValue={clientid}
                />
              </div>
              <div className="col">
                <label>Client Name</label>
                <input
                  className="form-control"
                  name="client_name"
                  defaultValue={clientname}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Job Title</label>
                <input
                  className="form-control"
                  name="job_title"
                  readOnly
                  defaultValue={getinterviewdetails?.job_position}
                />
              </div>
              <div className="col">
                <label>Interview Mode</label>
                <select
                  className="form-control"
                  name="interview_mode"
                  value={selectedMode}
                  onChange={(e) => handleModeChange(e.target.value)}
                >
                  <option value="">Select Mode</option>
                  {getinterviewdetails?.interview_design?.map((row, idx) => (
                    <option key={idx} value={row.interview_mode}>
                      {row.interview_mode}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>First Name</label>
                <input className="form-control" name="first_name" />
              </div>
              <div className="col">
                <label>Last Name</label>
                <input className="form-control" name="last_name" />
              </div>
            </div>

            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Interview Stage</label>
                <select
                  className="form-control"
                  name="interviewer_stage"
                  value={selectedStage}
                  onChange={(e) => handleStageChange(e.target.value)}
                >
                  <option value="">Select Stage</option>
                  {getinterviewdetails?.interview_design?.map((row, idx) => (
                    <option key={idx} value={row.interviewer_stage}>
                      {row.interviewer_stage}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col">
                <label>Email</label>
                <input className="form-control" name="email" />
              </div>
            </div>
            <hr />
            <h6>Add Interview Slots</h6>

            <div className="row mb-2 d-flex gap-3 align-items-center">
              <div className="col">
                <label>Select Date</label>
                <DatePicker
                  selected={slotDate}
                  onChange={(d) => setSlotDate(d)}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  placeholderText="Date"
                />
              </div>
              <div className="col">
                <label>Start Time</label>
                <DatePicker
                  selected={slotStart}
                  onChange={(t) => setSlotStart(t)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  timeCaption="Start"
                  dateFormat="HH:mm:ss"
                  className="form-control"
                  placeholderText="Start Time"
                />
              </div>
              <div className="col">
                <label>End Time</label>
                <DatePicker
                  selected={slotEnd}
                  onChange={(t) => setSlotEnd(t)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  timeCaption="End"
                  dateFormat="HH:mm:ss"
                  className="form-control"
                  placeholderText="End Time"
                />
              </div>
              <div className="col-auto mt-4">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleAddSlot}
                >
                  + Add Slot
                </button>
              </div>
            </div>

            {/* Display slots */}
            {slots.length > 0 && (
              <div className="mb-2">
                {slots.map((s, i) => (
                  <span key={i} className="badge bg-primary me-1 mb-1">
                    {s.date} ({s.start_time} - {s.end_time})
                    <button
                      type="button"
                      className="btn-close btn-close-white btn-sm ms-2"
                      aria-label="Close"
                      onClick={() => handleRemoveSlot(i)}
                      style={{ fontSize: "0.6rem" }}
                    ></button>
                  </span>
                ))}
              </div>
            )}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowAddModal(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              const form = document.getElementById("calenderForm");
              const formData = new FormData(form);
              handleSubmitAddModal(formData);
            }}
          >
            Add
          </button>
        </Modal.Footer>
      </Modal>

      {/* edit modal */}
      <Modal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          setSelectedEditData({});
        }}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Interview Calender Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="calenderForm">
            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Planning ID</label>
                <input
                  className="form-control"
                  name="plan_id"
                  defaultValue={selectedEditDate?.planning_id}
                  readOnly
                />
              </div>
              <div className="col">
                <label>Req ID</label>
                <input
                  className="form-control"
                  name="req_id"
                  defaultValue={selectedEditDate?.req_id}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Client ID</label>
                <input
                  className="form-control"
                  name="client_id"
                  readOnly
                  defaultValue={selectedEditDate?.client_id}
                />
              </div>
              <div className="col">
                <label>Client Name</label>
                <input
                  className="form-control"
                  name="client_name"
                  defaultValue={selectedEditDate?.client_name}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-2 d-flex gap-3">
              <div className="col">
                <label>Job Title</label>
                <input
                  className="form-control"
                  name="job_title"
                  readOnly
                  defaultValue={selectedEditDate?.job_title}
                />
              </div>
              <div className="col">
                <label>Interview Mode</label>
                <select
                  className="form-control"
                  name="interview_mode"
                  value={editSelectedMode}
                  onChange={(e) => handleEditModeChange(e.target.value)}
                >
                  <option value="">Select Mode</option>
                  {selectedEditDate?.interview_design?.map((row, idx) => (
                    <option key={idx} value={row.interview_mode}>
                      {row.interview_mode}
                    </option>
                  ))}
                </select>
              </div>

              <div className="row mb-2 d-flex gap-3">
                <div className="col">
                  <label>First Name</label>
                  <input
                    className="form-control"
                    name="first_name"
                    defaultValue={selectedEditDate?.first_name}
                  />
                </div>
                <div className="col">
                  <label>Last Name</label>
                  <input
                    className="form-control"
                    name="last_name"
                    defaultValue={selectedEditDate?.last_name}
                  />
                </div>
              </div>

              <div className="col">
                <label>Interview Stage</label>
                <select
                  className="form-control"
                  name="interviewer_stage"
                  value={editSelectedStage}
                  onChange={(e) => handleEditStageChange(e.target.value)}
                >
                  <option value="">Select Stage</option>
                  {selectedEditDate?.interview_design?.map((row, idx) => (
                    <option key={idx} value={row.interviewer_stage}>
                      {row.interviewer_stage}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col">
                <label>Email</label>
                <input
                  className="form-control"
                  name="email"
                  defaultValue={selectedEditDate?.email}
                />
              </div>
            </div>
            <hr />
            <h6>Add Interview Slots</h6>

            <div className="row mb-2 d-flex gap-3 align-items-center">
              <div className="col">
                <label>Select Date</label>
                <DatePicker
                  selected={slotDate}
                  onChange={(d) => setSlotDate(d)}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  placeholderText="Date"
                />
              </div>
              <div className="col">
                <label>Start Time</label>
                <DatePicker
                  selected={slotStart}
                  onChange={(t) => setSlotStart(t)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  timeCaption="Start"
                  dateFormat="HH:mm"
                  className="form-control"
                  placeholderText="Start Time"
                />
              </div>
              <div className="col">
                <label>End Time</label>
                <DatePicker
                  selected={slotEnd}
                  onChange={(t) => setSlotEnd(t)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  timeCaption="End"
                  dateFormat="HH:mm"
                  className="form-control"
                  placeholderText="End Time"
                />
              </div>
              <div className="col-auto mt-4">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleEditAddSlot}
                >
                  + Add Slot
                </button>
              </div>
            </div>

            {/* Display slots */}
            {editSlots.length > 0 && (
              <div className="mb-2">
                {editSlots.map((s, i) => (
                  <span key={i} className="badge bg-primary me-1 mb-1">
                    {s.date} ({s.start_time} - {s.end_time})
                    <button
                      type="button"
                      className="btn-close btn-close-white btn-sm ms-2"
                      aria-label="Close"
                      onClick={() => handleRemoveeditSlot(i)}
                      style={{ fontSize: "0.6rem" }}
                    ></button>
                  </span>
                ))}
              </div>
            )}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setShowEditModal(false);
              setSelectedEditData({});
            }}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              const form = document.getElementById("calenderForm");
              const formData = new FormData(form);
              handleSubmitEditModal(formData, selectedEditDate?.interviewer_id);
            }}
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>

      {/* delete pop-up */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Body>
          <p>Are you Sure You want to delete this record</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={""}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* upload modal */}
      <Modal show={showuploadmodal} onHide={() => setShowUploadModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Excel File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleupload}>
            <Form.Group controlId="formFile">
              <Form.Label>Select Excel File (.xlsx or .xls)</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx, .xls"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Form.Group>
            <div className="mt-3 d-flex justify-content-end">
              <Button
                variant="secondary"
                onClick={() => setShowUploadModal(false)}
                className="me-2"
              >
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Upload
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default UploadScreen;
